
<component
  :is="tagCompute"
  :id="id"
  :to="to"
  :href="hrefCompute"
  :disabled="disabled || loading"
  :loading="loading"
  class="button relative inline-flex justify-center uppercase font-medium text-s tracking-[1px] leading-normal"
  :class="[variantClass, sizeClass]"
  :target="target"
  :type="type"
  :aria-disabled="disabled || loading"
  :value="value"
  @click="clickEmitter"
  @focus="$emit('focus')"
>
  <!-- focus emit is necessary for SearchComboBox to work -->
  <Spinner v-if="loading" />
  <BackIcon v-if="variant === 'back'" class="mr-8" />
  <slot name="left-icon"></slot>
  <span :class="[`${loading && 'invisible'}`]">
    {{ value }}
  </span>
  <slot></slot>
  <Arrow v-if="variant === 'arrow'" />
</component>
